import React, { memo } from 'react';
import { Text, View } from 'react-native';
import { VehicleCardPayload } from './payloads';
import { useWidgetStyles } from './styles';

const modelYearLabel = (data: VehicleCardPayload): string =>
  data.modelYear ? `${data.modelYear}款` : '';

export const VehicleCardWidget = memo(
  ({ data }: { data: VehicleCardPayload }) => {
    const s = useWidgetStyles();

    const subtitle = [data.brandName, data.modelName, modelYearLabel(data)]
      .filter(Boolean)
      .join(' ');

    return (
      <View style={s.card}>
        <Text style={s.title}>{data.name || '车辆信息'}</Text>
        {subtitle && subtitle !== data.name ? (
          <Text style={s.meta}>{subtitle}</Text>
        ) : null}
        {data.licensePlateNo ? (
          <Text style={s.meta}>车牌: {data.licensePlateNo}</Text>
        ) : null}
        {data.fuelType ? (
          <Text style={s.meta}>燃油类型: {data.fuelType}</Text>
        ) : null}
        {data.vin ? <Text style={s.meta}>VIN: {data.vin}</Text> : null}
        {data.mileage != null ? (
          <Text style={s.meta}>里程: {data.mileage} km</Text>
        ) : null}
      </View>
    );
  },
);
